
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function CreditModal (props)
{
    function hide ()
    {
	props.hide();
    }
    
    return (
	<Modal
	    size="lg"
	    show={props.show}
	    onHide={hide}
	    centered
	>
	    <Modal.Header className="bg-light" closeButton>
		<Modal.Title className="w-100 d-flex align-items-center gap-2">
		    <div>Crédits</div>
		    <div>/</div>
		    <div>Contact : <a href="mailto:contact@legamelab.com">contact@legamelab.com</a></div>
		</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		<Row className="d-flex align-items-stretch mt-2 mb-3 me-2">
		    <Col sm={4} className="d-flex flex-column align-items-center gap-2">
			<div>Ce jeu a été développé par</div>
			<a href="https://legamelab.com/" target="_blank" rel="noreferrer"><img alt="Logo Le Gamelab" src={"./logo-le-gamelab.png"} width="250"/></a>
			<a href="https://legamelab.com/" target="_blank" rel="noreferrer">https://legamelab.com/</a>
			
		    </Col>
		    <Col sm={4} className="d-flex flex-column align-items-center justify-content-between">
			<div>Avec le soutien de</div>
			<a href="https://www.normandie.fr/" target="_blank" rel="noreferrer"><img alt="Logo Région Normandie" src={"./logo-region-normandie.png"} width="250"/></a>
			<a href="https://www.normandie.fr/" target="_blank" rel="noreferrer">https://www.normandie.fr/</a>
		    </Col>
		    <Col sm={4} className="d-flex flex-column align-items-center justify-content-between">
			<div className="text-center">Les images de ce jeu ont été générées à l'aide d'IA (<a href="https://www.stable-diffusion-france.fr/" target="_blank" rel="noreferrer">Stable Diffusion</a> et <a href="https://www.comfy.org/" target="_blank" rel="noreferrer">ComfyUi</a>) sur les conseils et grâce à un workflow mis en place par l'illustrateur <a href="https://creabd.net/" target="_blank" rel="noreferrer">CreaBd</a>.</div>
			<div className="d-flex align-items-center gap-2">
			    <a href="https://www.stable-diffusion-france.fr/" target="_blank" rel="noreferrer"><img alt="Logo Stable Diffusion" src={"./logo-stable-diffusion.png"} height="50"/></a>
			    <a href="https://www.comfy.org/" target="_blank" rel="noreferrer"><img alt="Logo ComfyUI" src={"./logo-comfyui.png"} height="50"/></a>
			    <a href="https://creabd.net/" target="_blank" rel="noreferrer"><img alt="Logo CréaBD" src={"./logo-creabd.png"} height="50"/></a>
			</div>
		    </Col>
		</Row>
	    </Modal.Body>
	</Modal>
    );
}

